<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">
        
        <!-- SECCIÓN SUPERIOR: Gráficos (círculo, muñeca, moño) -->
        <div class="top-graphics-wrapper">
          <img
            ref="circuloRef"
            src="@/assets/circulo.png"
            alt="Círculo de Rosas"
            class="circulo-img"
          >
          <img
            ref="quinceaneraRef"
            src="@/assets/quinceañera.png"
            alt="Quinceañera"
            class="quinceanera-img"
          >
          <img
            ref="monoRef"
            src="@/assets/monio2.png"
            alt="Moño Rojo"
            class="mono-img"
          >
        </div>

        <!-- SECCIÓN CENTRAL: Nombres y Texto -->
        <div class="centered-content">
          <div ref="letsHonorRef" class="lets-honor-text">ES UN HONOR INVITARTE A LA</div>
          <div ref="quinceaneraTitleRef" class="quinceanera-title">QUINCEAÑERA DE</div>
          <div ref="nombreRef" class="nombre-principal">Abigail Wence</div>
        </div>

        <!-- 🎭 MÁSCARA ESTÁTICA EN EL LADO IZQUIERDO -->
        <div class="mascara-left-container">
          <img 
            ref="mascaraRef" 
            src="@/assets/mascarr.png" 
            alt="Máscara Antifaz" 
            class="mascara-img-left"
          >
        </div>

        <!-- 🦋 CONTENEDOR DE MARIPOSAS -->
        <div class="butterflies-container">
          <img 
            ref="mariposa1Ref" 
            :src="mariposaImg" 
            alt="Mariposa 1" 
            class="mariposa-img vuelo-suave"
          >
          <img 
            ref="mariposa2Ref" 
            :src="mariposaImg" 
            alt="Mariposa 2" 
            class="mariposa-img vuelo-suave"
          >
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

// Importar la imagen explícitamente
import mariposaImg from '@/assets/mariposa.png'

export default {
  name: 'InvitacionQuinceanera',
  setup() {
    // Referencias HTML
    const fotoPortadaRef = ref(null)
    const circuloRef = ref(null)
    const quinceaneraRef = ref(null)
    const monoRef = ref(null)
    const letsHonorRef = ref(null)
    const quinceaneraTitleRef = ref(null)
    const nombreRef = ref(null)
    const fechaRef = ref(null)
    const btnMapsRef = ref(null)
    const mascaraRef = ref(null)
    
    // Referencias directas a las mariposas
    const mariposa1Ref = ref(null)
    const mariposa2Ref = ref(null)

    onMounted(() => {
      const w = window.innerWidth;
      const h = window.innerHeight;

      // ---------------------------------------------------------
      // 0. ESTADO INICIAL: MÁSCARA FIJA EN IZQUIERDA SIN MOVIMIENTO
      // ---------------------------------------------------------
      gsap.set(mascaraRef.value, { 
        opacity: 0
      });

      gsap.set(mariposa1Ref.value, { 
        x: w + 200, 
        y: h * 0.8, 
        opacity: 0, 
        scale: 0.7, 
        rotation: -20
      });

      gsap.set(mariposa2Ref.value, { 
        x: -200, 
        y: h * 0.9, 
        opacity: 0, 
        scale: 0.8, 
        rotation: 20
      });

      // ---------------------------------------------------------
      // 1. ANIMACIÓN DE ENTRADA PRINCIPAL
      // ---------------------------------------------------------
      gsap.from(fotoPortadaRef.value, { opacity: 0, y: 80, duration: 1.4, ease: 'power3.out' })
      const tl = gsap.timeline({ delay: 0.8 });
      tl.fromTo(circuloRef.value, { opacity: 0, y: -150, scale: 1.8, filter: 'blur(15px)' }, { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: 1.8, ease: 'power4.out' }, 0);
      tl.from(quinceaneraRef.value, { opacity: 0, y: 50, duration: 1.5, ease: 'power3.out' }, 0.8);
      tl.from(monoRef.value, { opacity: 0, scale: 0, duration: 1.2, ease: 'back.out(1.8)' }, 1.2);
      tl.from([letsHonorRef.value, quinceaneraTitleRef.value], { opacity: 0, y: 30, duration: 1, stagger: 0.2, ease: 'power2.out' }, "-=0.5");
      tl.from(nombreRef.value, { opacity: 0, y: 40, duration: 1.4, ease: 'back.out(1.7)' }, "-=0.3");
      tl.from(fechaRef.value, { opacity: 0, scale: 0.9, duration: 1, ease: 'power3.out' }, "+=0.1");
      tl.from(btnMapsRef.value, { opacity: 0, scale: 0, duration: 0.8, ease: 'back.out(2)' }, "+=0.3");

      // ---------------------------------------------------------
      // 🦋 2. ANIMACIÓN DE MARIPOSA Y APARICIÓN ESTÁTICA DE MÁSCARA
      // ---------------------------------------------------------
      const tlFlight = gsap.timeline({ repeat: -1 });

      // La máscara simplemente se hace visible de golpe/fade en su posición fija izquierda
      tlFlight.to(mascaraRef.value, {
        duration: 1,
        opacity: 1,
        ease: "power1.inOut"
      }, 0);

      // Animación de vuelo normal solo para la Mariposa 1 al mismo tiempo
      tlFlight.to(mariposa1Ref.value, {
        duration: 5,
        x: w * 0.5,
        y: h * 0.5,
        opacity: 1,
        ease: "sine.inOut"
      }, 0)
      .to(mariposa1Ref.value, {
        duration: 5,
        x: -200,
        y: h * 0.1,
        opacity: 0,
        ease: "sine.inOut"
      })
      .set(mariposa1Ref.value, {
        x: w + 200,
        y: h * 0.8,
        opacity: 0,
        scale: 0.7,
        rotation: -20
      });

      // --- Mariposa 2 ---
      tlFlight.to(mariposa2Ref.value, {
        duration: 5,
        x: w * 0.5,
        y: h * 0.5,
        opacity: 1,
        ease: "sine.inOut"
      }, 5)
      .to(mariposa2Ref.value, {
        duration: 5,
        x: w + 200,
        y: h * 0.2,
        opacity: 0,
        ease: "sine.inOut"
      })
      .set(mariposa2Ref.value, {
        x: -200,
        y: h * 0.9,
        opacity: 0,
        scale: 0.8,
        rotation: 20
      });
    })

    return {
      fotoPortadaRef, circuloRef, quinceaneraRef, monoRef, letsHonorRef,
      quinceaneraTitleRef, nombreRef, fechaRef, btnMapsRef, mascaraRef,
      mariposa1Ref, mariposa2Ref,
      mariposaImg
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. ESTILOS BASE Y CONTENEDORES (AJUSTE NATURAL)
   ========================================== */
.fotoportada-container {
  position: relative;
  width: 100%;
  height: auto; /* 🔥 Deja que el contenido defina la altura exacta */
  background-color: #fff;
  z-index: 1;
}

.overlay {
  position: relative; /* 🔥 Permite que empuje la siguiente sección */
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 30px;
  padding-bottom: 20px; /* 🔥 Controla la distancia con la siguiente sección */
  z-index: 2;
  box-sizing: border-box;
}

/* ==========================================
   2. GRÁFICOS SUPERIORES
   ========================================== */
.top-graphics-wrapper {
  position: relative;
  width: 90vw;
  max-width: 480px;
  display: flex;
  margin-top:40px;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.circulo-img {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 1;
}

.quinceanera-img {
  width: 92%;
  height: auto;
  position: absolute;
  top: 57% !important;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.mono-img {
  width: 75%;
  height: auto;
  margin-top: -35%; /* 🔥 Proporcional al ancho, funciona igual en cualquier pantalla */
  position: relative;
  z-index: 3;
}

/* ==========================================
   3. TEXTOS Y CONTENIDO CENTRAL
   ========================================== */
.centered-content {
  text-align: center;
  color: #8C6F4D;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 40px; /* 🔥 Margen controlado sin separar componentes */
  z-index: 4;
  width: 90vw;
}

.lets-honor-text {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.75rem, 3vw, 0.95rem);
  font-weight: 600;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: #B28F60;
}

.quinceanera-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.4rem, 6vw, 1.8rem);
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #B28F60;
  margin-top: -4px;
}

.nombre-principal {
  font-family: 'ludovica', serif;
  font-size: clamp(3.2rem, 15vw, 5.2rem);
  font-weight: 500;
  line-height: 1;
  color: #9C1B2C;
  margin: 10px 0 0 0;
}

/* ==========================================
   4. 🎭 MÁSCARA LADO IZQUIERDO
   ========================================== */
.mascara-left-container {
  position: absolute;
  top: 45px;
  left: 10px;
  pointer-events: none;
  z-index: 5;
}

.mascara-img-left {
  width: clamp(180px, 40vw, 230px);
  height: auto;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));
  transform: rotate(-15deg);
}

/* ==========================================
   5. 🦋 MARIPOSAS Y ANIMACIÓN
   ========================================== */
.butterflies-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 100;
  overflow: hidden;
  perspective: 1000px;
}

.mariposa-img {
  position: absolute;
  width: clamp(70px, 22vw, 110px) !important;
  height: auto;
  margin-top:42px;
  opacity: 1 !important;
  will-change: transform;
  transform-origin: center bottom;
}

/* Keyframes de Aleteo */
@keyframes vueloSuave {
  0%, 100% {
    transform: translateY(0px) scaleX(1);
  }
  50% {
    transform: translateY(-3px) scaleX(0.75);
  }
}

.vuelo-suave {
  animation: vueloSuave 0.6s infinite ease-in-out;
}
</style>